import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import Modal from '@components/Modal/Modal';
import { handleDeleteInquiryDraft } from '@store/features/inquiryDraft/deleteInquiryDraft/actions';
import { handleRemoveSupplementFromInquiryDraft } from '@store/features/inquiryDraft/removeSupplementFromInquiryDraft/actions';
import useDispatch from '@store/hooks/useDispatch';

import { INotificationModalProps, TSupplementType } from './NotificationModal.interface';

import './style.scss';

const NotificationModal: FC<INotificationModalProps> = ({
  open,
  onClose,
  onExited,
  dietarySupplementInModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onConfirm = useCallback(() => {
    if (!dietarySupplementInModal) return;

    const id = +dietarySupplementInModal.supplementId;

    if (dietarySupplementInModal.type === TSupplementType.INQUIRY) {
      dispatch(handleDeleteInquiryDraft({ id }));
    } else if (dietarySupplementInModal.type === TSupplementType.INQUIRY_ITEM) {
      dispatch(handleRemoveSupplementFromInquiryDraft({ id }));
    }
  }, [dietarySupplementInModal, dispatch]);

  const handleConfirm = useCallback((): void => {
    onConfirm();
    onClose();
  }, [onClose, onConfirm]);

  const notificationDescriptionText =
    dietarySupplementInModal?.type === TSupplementType.INQUIRY
      ? t('dietarySupplementInquiry.removeInquiryNotification')
      : t('dietarySupplementInquiry.removeInquiryItemNotification');

  return (
    <Modal
      onClose={onClose}
      onExited={onExited}
      open={open}
      className="inquiry-notification-modal"
      leftActionTitle={t('common.cancel')}
      onLeftAction={onClose}
      rightActionTitle={t('dietarySupplementInquiry.removeInquiry')}
      onRightAction={handleConfirm}
    >
      <Box
        component="img"
        className="inquiry-notification-modal__image"
        src="/images/img-shredder.svg"
      />
      {notificationDescriptionText && (
        <p className="inquiry-notification-modal__caption">{notificationDescriptionText}</p>
      )}
      <h5 className="inquiry-notification-modal__sub-caption">
        {t('dietarySupplementInquiry.thisCannotBeUndone')}
      </h5>
    </Modal>
  );
};

export default NotificationModal;
